import { Checkbox, FormField, Label, LabeledControl } from '@zillow/constellation-10';

type Props = {
  checked: boolean;
  onClick: () => void;
};

export default function LeaseAttachedCheckbox({ ...props }: Props) {
  return (
    <FormField
      label={<Label optional>Signed lease email notification</Label>}
      control={<LabeledControl label={<Label>Email me my signed lease</Label>} control={<Checkbox {...props} />} />}
    />
  );
}
